import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { GlobalService } from '../services/global.service';
import { PremissasService } from '../services/premissas.service';
import { Premissas } from '../models/premissas';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { MatDialog } from '@angular/material';
import { ConfiguraAppOctopusComponent } from '../modals/configura-app-octopus/configura-app-octopus.component';
import {
  ApplicationDto,
  CreateOrganizationRequest,
  OrganizationDto, StatusType,
  StoreDto, UpdateOrganizationRequest, UpdateOrgAppRequest
} from '../hopper/octopus/client';
import { HopperOctopusConfiguration, HopperOctopusOptions } from "../hopper";
import { OctopusService } from "../services/octopusService";

declare const $: any;

@Component({
  selector: 'app-loja-integracoes',
  templateUrl: './loja-integracoes.component.html',
  styleUrls: ['./loja-integracoes.component.scss']
})
export class LojaIntegracoesComponent implements OnInit {
  suporte = false;
  administrador = false;
  model: any;

  empresa = new Premissas();

  hopperConfig = new HopperOctopusOptions();
  organization: OrganizationDto = new OrganizationDto();
  stores: StoreDto[] = [];
  storeIdSelecionado = null;
  apps: ApplicationDto[] = [];
  categorias: string[] = [];
  appsGroupByCategory: { [key: string]: ApplicationDto[] } = {};

  constructor(
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private router: Router,
    public dialog: MatDialog,
    @Inject(HopperOctopusConfiguration) private hopperConfigService: HopperOctopusConfiguration,
    private hopperOctopusGiService: OctopusService,
  ) { }

  async ngOnInit() {
    this.suporte = await this.globalService.suporte();
    this.administrador = await this.globalService.administrador();

    this.buscarConfiguracoesEmpresa();
    this.buscarConfiguracoesHopper();

    if (this.suporte) {
      this.buscarLojas();
      this.buscarOrganizacaoOctopus();
    }

    this.buscarApps();
  }

  buscarConfiguracoesEmpresa() {
    this.carregandoService.mostra('buscarConfiguracoesEmpresa');
    this.premissasService.consultarPremissas().subscribe(resp => {
      this.empresa = resp;
      this.carregandoService.esconde('buscarConfiguracoesEmpresa');
    }, () => {
      this.carregandoService.esconde('buscarConfiguracoesEmpresa');
      this.notificacaoService.erro('Não foi possível carregar as configuações da empresa');
    });
  }

  buscarConfiguracoesHopper() {
    const config = this.hopperConfigService.getConfig();
    this.hopperConfig = Object.assign({}, config);
  }

  buscarLojas() {
    if (!this.hopperOctopusGiService.hasClient()) {
      return;
    }

    this.carregandoService.mostra('buscarLojas');
    this.hopperOctopusGiService.client.hubStoreListEndpoint().subscribe(data => {
      this.stores = data.result;
      this.carregandoService.esconde('buscarLojas');
    }, (erro) => {
      this.carregandoService.esconde('buscarLojas');
      this.notificacaoService.erro("Não foi possível buscar lojas no HUB.");
    });
  }

  buscarOrganizacaoOctopus() {
    if (!this.hopperOctopusGiService.isConfigured()) {
      return;
    }

    this.carregandoService.mostra('buscarOrganizacaoOctopus');
    this.hopperOctopusGiService.client.hubOrganizationGetEndpoint().subscribe(data => {
      this.organization = data.result;
      this.storeIdSelecionado = this.organization.store.id;
      this.carregandoService.esconde('buscarOrganizacaoOctopus');
    }, (erro) => {
      this.carregandoService.esconde('buscarOrganizacaoOctopus');
      this.notificacaoService.erro('Não foi possível buscar a empresa no HUB');
    });
  }

  buscarApps() {
    if (!this.hopperOctopusGiService.isConfigured()) {
      return;
    }

    this.carregandoService.mostra('buscarApps');
    this.hopperOctopusGiService.client.hubApplicationListEndpoint().subscribe(data => {
      this.apps = data.result;
      this.categorias = data.result.reduce((categorias, app) => {
        const categoria = app.category.name;

        if (!categorias.includes(categoria)) {
          categorias.push(categoria);
        }

        return categorias;
      }, []);

      this.appsGroupByCategory = this.apps.reduce((categorias, app) => {
        const categoria = app.category.name;

        if (!categorias[categoria]) {
          categorias[categoria] = [];
        }

        categorias[categoria].push(app);

        return categorias;
      }, {});

      this.carregandoService.esconde('buscarApps');
    }, (erro) => {
      this.carregandoService.esconde('buscarApps');
      this.notificacaoService.erro('Não foi possível buscar aplicativos no HUB');
    });
  }

  configurarOctopus() {
    if (!this.hopperOctopusGiService.hasClient()) {
      this.carregandoService.mostra('hopperGiConfigService');
      this.hopperConfigService
        .setConfigAsync(this.hopperConfig)
        .then(() => {
          this.carregandoService.esconde('hopperGiConfigService');
          location.reload();
        })
        .catch(() => {
          this.carregandoService.esconde('hopperGiConfigService');
          this.notificacaoService.erro('Não foi possível salvar as configurações do HUB');
        });
    } else if (!this.hopperOctopusGiService.isConfigured()) {
      const organization: CreateOrganizationRequest = new CreateOrganizationRequest(
        {
          name: this.empresa.fantasia,
          displayName: this.empresa.fantasia,
          storeId: this.storeIdSelecionado,
          commonId: this.empresa.codEverest,
          clientId: '00000000-0000-0000-0000-000000000000',
          clientSecret: '00000000-0000-0000-0000-000000000000',
        }
      );

      this.carregandoService.mostra('conectarEmpresa');
      this.hopperOctopusGiService.conectarEmpresa(organization).subscribe(data => {
        this.organization = data.result;
        this.storeIdSelecionado = this.organization.store.id;
        this.carregandoService.esconde('conectarEmpresa');

        swal({
          title: 'Empresa Conectada!!',
          html: 'Para continuar, é necessário fazer o login novamente. Deseja continuar?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['/login']);
          } else {
            this.hopperConfigService.initializeAsync().then();
            this.router.navigate(['/']);
          }
        });

        this.buscarApps();
      }, () => {
        this.carregandoService.esconde('conectarEmpresa')
        this.notificacaoService.erro('Não foi possível conectar a empresa no HUB');
      });
    } else if (this.hopperOctopusGiService.isConfigured()) {
      this.carregandoService.mostra('atualizarEmpresa');

      const update: UpdateOrganizationRequest = new UpdateOrganizationRequest(
        {
          name: this.organization.name,
          displayName: this.organization.displayName,
          commonId: this.organization.commonId,
          storeId: this.storeIdSelecionado,
        }
      );

      this.hopperOctopusGiService.atualizarEmpresa(update).subscribe(data => {
        this.organization = data.result;
        this.storeIdSelecionado = this.organization.store.id;
        this.carregandoService.esconde('atualizarEmpresa')

        this.buscarApps();
      }, () => {
        this.carregandoService.esconde('atualizarEmpresa')
        this.notificacaoService.erro('Não foi possível atualizar a empresa no HUB')
      });
    }
  }

  desconectarOctopus() {
    this.carregandoService.mostra('desconectarOctopus');

    this.hopperOctopusGiService.desconectarEmpresa().subscribe(() => {
      this.carregandoService.esconde('desconectarOctopus');
      location.reload();
    }, () => {
      this.carregandoService.esconde('desconectarOctopus');
      this.notificacaoService.erro('Não foi possível desconectar a empresa do HUB')
    });
  }

  podeConfigurar(): boolean {
    return this.suporte;
  }

  podeConectar(): boolean {
    return !this.hopperOctopusGiService.isConfigured();
  }

  podeDesconectar(): boolean {
    return this.hopperOctopusGiService.isConfigured();
  }

  podeAtualizar(): boolean {
    return this.hopperOctopusGiService.isConfigured();
  }

  podeVisualizarLojas(): boolean {
    return this.hopperOctopusGiService.hasClient();
  }

  podeVisualizarApps(): boolean {
    return this.hopperOctopusGiService.isConfigured();
  }

  podeInstalarApp(app: ApplicationDto): boolean {
    return app.orgApp === undefined || app.orgApp === null;
  }

  podeConfigurarApp(app: ApplicationDto): boolean {
    return app.orgApp !== undefined && app.orgApp !== null && app.orgApp.status !== StatusType.Deleted;
  }

  podeDesinstalarApp(app: ApplicationDto): boolean {
    return app.orgApp !== undefined && app.orgApp !== null && (app.orgApp.status !== StatusType.Deleted || this.suporte);
  }

  validarErrosConfiguracao(): boolean {
    if (!this.hopperOctopusGiService.hasClient()) {
      return this.hopperConfig.apiUrl === undefined || this.hopperConfig.apiUrl === null || this.hopperConfig.apiUrl === '';
    } else {
      return this.storeIdSelecionado === undefined || this.storeIdSelecionado === null || this.storeIdSelecionado === 0;
    }
  }

  instalarApp(app: ApplicationDto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(ConfiguraAppOctopusComponent, {
      width: largura > 1100 ? "700px" : $("body").width().toString() + "px",
      data: {
        applicationId: app.id,
        applicationName: app.name,
        optionsSchema: app.optionsSchema,
        orgAppId: app.orgApp !== undefined && app.orgApp !== null ? app.orgApp.id : null
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarApps();
      }
    });
  }

  alterarApp(app: ApplicationDto) {
    this.carregandoService.mostra('alterarApp');

    this.hopperOctopusGiService.client.hubOrgAppGetEndpoint(app.orgApp.id).subscribe(
      (resp) => {
        const orgApp = resp.result;

        if (orgApp.status === StatusType.Active) {
          orgApp.status = StatusType.Inactive;
        } else {
          orgApp.status = StatusType.Active;
        }

        const data = new UpdateOrgAppRequest( {
          optionsModel: orgApp.optionsModel,
          status: orgApp.status
        });

        this.hopperOctopusGiService.client.hubOrgAppUpdateEndpoint(orgApp.id, data).subscribe(
          () => {
            this.carregandoService.esconde('alterarApp');
            this.buscarApps();
          }, (erro) => {
            this.carregandoService.esconde('alterarApp');
            this.notificacaoService.erro('Não foi possível salvar a configuração do aplicativo.');
            this.buscarApps();
          });
      }, () => {
        this.carregandoService.esconde('alterarApp');
        this.notificacaoService.erro('Não foi possível localizar o aplicativo.');
      });
  }

  desinstalarApp(app: ApplicationDto) {
    this.carregandoService.mostra('desinstalarApp');
    this.hopperOctopusGiService.client.hubOrgAppDeleteEndpoint(app.orgApp.id).subscribe(data => {
      this.carregandoService.esconde('desinstalarApp');
      this.notificacaoService.sucesso(`O app ${app.orgApp.displayName} foi desinstalado com sucesso!`);
      this.buscarApps();
    }, (erro) => {
      this.carregandoService.esconde('desinstalarApp');
      this.notificacaoService.erro(`Não foi possível desinstalar o app: ${app.orgApp.displayName}`);
    });
  }
}
